import _ from 'underscore';

export const convertOptions = (options) => {
  let params = {
    ...options,
  };
  if (typeof options === 'string') {
    params = { pathname: options };
  }
  return {
    ...params,
    search: params.search || window.location.search,
  };
};

function processValue(value) {
  const pattern = /^[0-9]+$/g;
  const SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
  let isInt = _.isString(value) ? value.match(pattern) : false;
  let intValue;
  if (isInt) {
    intValue = parseInt(value, 10);
    isInt = intValue.toString() === value && intValue <= SAFE_INTEGER;
  }
  return isInt ? intValue : value;
}

export const getQuery = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const entries = urlParams.entries();
  const result = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of entries) {
    result[key] = processValue(value);
  }
  return result;
};
